<template>
  <section>
    <span data-test="infotext" v-html="$tc('cita.infotext2', msisdn)" />
    <VProgress class="offset-top-2 offset-bottom-2" :steps="steps" active="cita.youridentcode" />
    <span>{{ $t('cita.cap_otp_request') }}</span>

    <hr />

    <div class="offset-top-2 text-right">
      <transition name="fade" mode="out-in" appear>
        <VSpinner v-if="isBusy" slim class="pull-left" />
      </transition>
      <VButton tag="a" class="offset-left-1 offset-bottom-1 btn btn-default" label="cita.abort" :disabled="isBusy" @click.prevent="onAbort" />
      <VButton
        type="submit"
        class="offset-left-1 offset-bottom-1 btn btn-default btn-brand"
        label="cita.label_request_cap_otp"
        :disabled="isBusy"
        @click.prevent="onNext"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TitleMixin from '@/mixins/title';
import CitaStepsMixin from '@/mixins/citaSteps';
import VSpinner from '@/components/Spinner';
import Proxy from '@/proxies/CitaProxy';
import { safeNavigate } from '@/utils/safeUrl';
import { CITA_CONFIRM } from '@/router/route-types';

export default {
  name: 'CitaRequest',

  components: {
    VSpinner,
    VProgress: () => import('@/components/Progress'),
    VButton: () => import('@/components/Button'),
  },

  mixins: [TitleMixin, CitaStepsMixin],

  data() {
    return {
      isBusy: false,
    };
  },

  computed: {
    ...mapState('system', ['sessionId', 'entranceType']),
    ...mapState('cita', ['msisdn', 'refUrl']),
    ...mapGetters('cita', ['getPageTypeWebtrekk']),
  },

  created() {
    if (this.entranceType === 'CITA_RETURN_ITS') {
      this.$webtrekk.viewPage(`cita.${this.getPageTypeWebtrekk}.identifikation-via-its`);
    }
    this.$webtrekk.viewPage(`cita.${this.getPageTypeWebtrekk}.identifikationscode`);
  },

  methods: {
    async onAbort() {
      this.isBusy = true;
      await new Proxy().confirm(false, this.sessionId, null, null);
      await this.$webtrekk.link('cita.abort', this.refUrl);
      // SECURITY: safeNavigate refuses non-http(s) URLs (blocks javascript:/data: XSS).
      safeNavigate(this.refUrl);
    },

    async onNext() {
      this.isBusy = true;
      await new Proxy().otpRequest();
      this.$router.replace({ name: CITA_CONFIRM });
      this.$webtrekk.link('cita.label_request_cap_otp', CITA_CONFIRM);
    },
  },
};
</script>
